<template>
    <div class="page">
        <loader v-if="loadingTab" />
        <div class="vertical-flow">
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t('cliente') }}
                        <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                            <b-icon
                                v-if="!hide.infoIsHidden"
                                icon="eye-off-outline"
                                type="is-danger"
                            />
                            <b-icon v-if="hide.infoIsHidden" icon="eye-outline" type="is-success" />
                        </a>
                    </h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a class="a-inativo">{{ isVenda ? $t('vendas') : $t('agro') }}</a>
                            </li>
                            <li>
                                <a @click="$router.push({ name: `${abrev}-cliente-list` })">{{
                                    $t('clientes')
                                }}</a>
                            </li>
                            <li>
                                <a aria-current="page">{{
                                    $route.params.id
                                        ? `${$route.params.id} - ${
                                              loadingName ? $t('carregando') : name
                                          }`
                                        : $t('novo')
                                }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="header-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        tag="button"
                        @click="$router.push({ name: `${abrev}-cliente-list` })"
                    >
                        {{ $t('voltar') }}
                    </button>
                </div>
            </div>

            <ul class="nav nav-tabs nav-tabs-main">
                <router-link
                    v-if="isUpdate && permissaoDadosCadastrais.read"
                    tag="li"
                    :to="{
                        name: `${abrev}-cliente-dados-cadastrais-${isUpdate ? 'edit' : 'new'}`,
                        query: {
                            dadoscadastrais: $route.query.dadoscadastrais
                                ? $route.query.dadoscadastrais
                                : null,
                            politicacomercial: $route.query.politicacomercial
                                ? $route.query.politicacomercial
                                : null,
                            analisecomercial: abaSelecionada,
                        },
                    }"
                >
                    <a>{{ $t('dados-cadastrais') }}</a>
                </router-link>
                <router-link
                    v-if="isUpdate && permissaoPoliticaComercial.read"
                    tag="li"
                    :to="{
                        name: `${abrev}-cliente-politica-comercial-${isUpdate ? 'edit' : 'new'}`,
                        query: {
                            dadoscadastrais: $route.query.dadoscadastrais
                                ? $route.query.dadoscadastrais
                                : null,
                            politicacomercial: $route.query.politicacomercial
                                ? $route.query.politicacomercial
                                : null,
                            analisecomercial: abaSelecionada,
                        },
                    }"
                >
                    <a>{{ $t('politica-comercial') }}</a>
                </router-link>
                <router-link
                    v-if="isUpdate"
                    tag="li"
                    :to="{
                        name: `${abrev}-cliente-analise-comercial-${isUpdate ? 'edit' : 'new'}`,
                        params: { id: $route.params.id },
                    }"
                >
                    <a>{{ $t('analise-comercial') }}</a>
                </router-link>
            </ul>

            <ul class="nav nav-tabs nav-tabs-children">
                <li
                    v-for="(aba, i) in abas"
                    :key="i"
                    v-show="listaPermissoes[aba].read"
                    :class="{ active: abaSelecionada == i }"
                    @click="changeTab(i)"
                >
                    <a data-toggle="tab">{{ $t(aba) }}</a>
                </li>
            </ul>

            <!-- CONJTO DE ABAS - MOBILE -->
            <b-dropdown aria-role="list" class="mobile-tab-list">
                <div slot="trigger" class="mobile-tab">
                    <span class="mobile-tab-text">
                        {{ $t(abas[abaSelecionada]) }}
                    </span>
                    <em class="mdi mdi-chevron-down"></em>
                </div>

                <b-dropdown-item
                    class="mobile-tab-list-item"
                    :class="{ active: abaSelecionada == i }"
                    aria-role="listitem"
                    v-for="(aba, i) in abas"
                    v-show="listaPermissoes[aba].read"
                    :key="i"
                    @click="changeTab(i)"
                >
                    {{ $t(aba) }}
                </b-dropdown-item>
            </b-dropdown>

            <!-- COCKPIT -->
            <Cockpit
                ref="tabCockpit"
                v-if="abasAbertas['cockpit'] && listaPermissoes['cockpit'].read"
                v-show="abas[abaSelecionada] == 'cockpit'"
            />

            <!-- HISTORICO PEDIDO -->
            <HistoricoPedido
                ref="tabHistoricoPedido"
                v-if="abasAbertas['historico-pedidos'] && listaPermissoes['historico-pedidos'].read"
                v-show="abas[abaSelecionada] == 'historico-pedidos'"
            />

            <!-- TOMADA PRECO -->
            <TomadaPreco
                ref="refTomadaPreco"
                v-if="abasAbertas['tomada-preco'] && listaPermissoes['tomada-preco'].read"
                v-show="abas[abaSelecionada] == 'tomada-preco'"
            />

            <!-- NAO VENDA -->
            <NaoVenda
                ref="tabNaoVenda"
                v-if="abasAbertas['tomada-preco'] && listaPermissoes['nao-venda'].read"
                v-show="abas[abaSelecionada] == 'nao-venda'"
            />

            <!-- ATENDIMENTO -->
            <Atendimento
                ref="tabAtendimento"
                v-if="abasAbertas['atendimento'] && listaPermissoes['atendimento'].read"
                v-show="abas[abaSelecionada] == 'atendimento'"
            />

            <!-- MIX -->
            <Mix
                ref="tabMix"
                v-if="abasAbertas['mix'] && listaPermissoes['mix'].read"
                v-show="abas[abaSelecionada] == 'mix'"
                @alert="showMessageFromTab"
                :data="tabData.mix"
                @load-page="loadTabMix"
            />

            <!-- CheckInOut -->
            <CheckInOut
                ref="tabChecks"
                v-if="abasAbertas['check-in-out'] && listaPermissoes['check-in-out'].read"
                v-show="abas[abaSelecionada] == 'check-in-out'"
                :data="tabData.checkInOut"
                @load-page="loadTabChecks"
                @alert="showMessageFromTab"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

// service
import VendasClienteService from '@/services/VendasClienteService';
import ClienteService from '@/services/vendas/cliente/ClienteService';

// Abas
import Cockpit from '@/components/vendas/cliente/abas/analise-comercial/Cockpit';
import HistoricoPedido from '@/components/vendas/cliente/abas/analise-comercial/HistoricoPedido';
import TomadaPreco from '@/components/vendas/cliente/abas/analise-comercial/TomadaPreco';
import NaoVenda from '@/components/vendas/cliente/abas/analise-comercial/NaoVenda';
import Atendimento from '@/components/vendas/cliente/abas/analise-comercial/Atendimento';
import Mix from '@/components/vendas/cliente/abas/analise-comercial/Mix';
import CheckInOut from '@/components/vendas/cliente/abas/analise-comercial/CheckInOut';

export default {
    components: {
        Cockpit,
        HistoricoPedido,
        TomadaPreco,
        NaoVenda,
        Atendimento,
        Mix,
        CheckInOut,
    },
    data() {
        return {
            id: 0,
            abaSelecionada: 0,
            // Seguir nome na tabela app_tela e usar estes nomes no dicionário para criação dinâmica de listaPermissoes e abasAbertas
            abas: [
                // 'cockpit',
                // 'historico-pedidos',
                // 'tomada-preco',
                // 'nao-venda',
                // 'atendimento',
                'mix',
                'check-in-out',
            ],
            abasAbertas: {},
            permissaoDadosCadastrais: false,
            permissaoAnaliseComercial: false,
            permissaoPoliticaComercial: false,
            listaPermissoes: {},
            isUpdate: false,
            service: new VendasClienteService(this.$http, this.$router),
            tabData: {
                mix: { page: 1, perPage: 20 },
                checkInOut: { page: 1, perPage: 20 },
            },
            loadingTab: false,
            name: null,
            loadingName: false,
            serviceCliente: new ClienteService(this.$http, this.$router),
            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    mounted() {
        if (this.$route.query.analisecomercial && this.$route.params.id) {
            this.changeTab(
                this.$route.query.analisecomercial < this.abas.length
                    ? this.$route.query.analisecomercial
                    : 0
            );
        }
    },
    created() {
        this.id = this.$route.params.id;

        if (this.$route.params.id) this.isUpdate = true;

        if (this.isVenda) {
            this.permissaoAnaliseComercial = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-analise-comercial'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissaoAnaliseComercial = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-analise-comercial'
            );
        }

        if (
            (!this.isUpdate && !this.permissaoAnaliseComercial.create) ||
            (this.isUpdate && !this.permissaoAnaliseComercial.update) ||
            !this.permissaoAnaliseComercial.read
        ) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            if (this.isUpdate) this.loadName();
            // Criação dinâmica de listaPermissoes e abasAbertas baseado no nome das tabs
            for (let [key, value] of Object.entries(this.abas)) {
                this.abasAbertas[value] = false;
                if (this.isVenda) {
                    this.listaPermissoes[value] = this.hasPermissionAccess(
                        'vendas',
                        'clientes',
                        `ven-cliente-analise-comercial-${value}`
                    );
                } else if (this.isAgro) {
                    this.listaPermissoes[value] = this.hasPermissionAccess(
                        'agro',
                        'clientes',
                        `agro-cliente-analise-comercial-${value}`
                    );
                }
            }

            if (this.isVenda) {
                this.permissaoDadosCadastrais = this.hasPermissionAccess(
                    'vendas',
                    'clientes',
                    'ven-cliente-dados-cadastrais'
                );
                this.permissaoPoliticaComercial = this.hasPermissionAccess(
                    'vendas',
                    'clientes',
                    'ven-cliente-politica-comercial'
                );
            } else if (this.isAgro) {
                this.permissaoDadosCadastrais = this.hasPermissionAccess(
                    'agro',
                    'clientes',
                    'agro-cliente-dados-cadastrais'
                );
                this.permissaoPoliticaComercial = this.hasPermissionAccess(
                    'agro',
                    'clientes',
                    'agro-cliente-politica-comercial'
                );
            }

            // Pegar dinâmicamente a primeira aba que estivar com permissão de leitura para a mesma iciciar visível
            for (let [key, value] of Object.entries(this.listaPermissoes)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }

            this.loadTab(this.abaSelecionada);
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        loadName() {
            this.loadingName = true;
            this.loadNameAC()
                .then((res) => {
                    this.name = res.content.nome;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.loadingName = false;
                });
        },
        loadNameAC() {
            if (this.isVenda) return this.serviceCliente.loadNameVendas(this.$route.params.id);
            else return this.serviceCliente.loadNameAgro(this.$route.params.id);
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
            this.loadTab(this.abaSelecionada);
        },
        loadTab(i) {
            this.loadingTab = true;

            this.findAba().then((result) => {
                this.tabData.geral = result.content;

                if (this.abas[i] == 'check-in-out') {
                    this.loadTabChecks({
                        page: this.tabData.checkInOut.page,
                        limit: this.tabData.checkInOut.perPage,
                        column: 'idcheck',
                        order: 'desc',
                    });
                } else if (this.abas[i] == 'mix') {
                    this.loadTabMix({
                        page: this.tabData.mix.page,
                        limit: this.tabData.mix.perPage,
                        column: '',
                        order: '',
                    });
                } else {
                    console.error(`Aba inválida: ${i}`);
                    this.loadingTab = false;
                }
            });
        },
        findAba() {
            if (this.isVenda) return this.serviceCliente.findVendas(this.id);
            else return this.serviceCliente.findAgro(this.id);
        },
        loadTabChecks(info) {
            this.tabData.checkInOut.page = info.page;

            this.service
                .loadChecks(
                    this.id,
                    info.page ? info.page - 1 : 0,
                    info.limit ? info.limit : 20,
                    info.column,
                    info.order
                )
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`Status ${r.status} ao carregar aba checkin/out.`);
                        console.error(r.message ? r.message : 'Sem mensagem.');
                        this.$root.showMessage('error', 'msg-erro-ven-cliente-checks-load');
                    } else {
                        this.tabData.checkInOut.table = r.content;
                        this.tabData.checkInOut.total = r.totalElements;

                        if (this.$refs.tabChecks != undefined) {
                            this.$refs.tabChecks.$forceUpdate();
                        }
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar aba checkin/out', e);
                    this.$root.showMessage('error', 'msg-erro-ven-cliente-checks-load');
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        showMessageFromTab(data) {
            this.$root.showMessage(data.type, data.message);
        },
        loadTabMix(info) {
            this.tabData.mix.page = info.page;

            this.service
                .loadMix(
                    this.id,
                    info.page ? info.page - 1 : 0,
                    info.limit ? info.limit : 20,
                    info.column,
                    info.order
                )
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`Status ${r.status} ao carregar aba mix.`);
                        console.error(r.message ? r.message : 'Sem mensagem.');
                        this.$root.showMessage('error', 'msg-erro-ven-cliente-mix-load');
                    } else {
                        this.tabData.mix.table = r.content;
                        this.tabData.mix.total = r.totalElements;
                        this.tabData.mix.cliente = this.tabData.geral;

                        if (this.$refs.tabMix != undefined) {
                            this.$refs.tabMix.$forceUpdate();
                        }
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar aba mix', e);
                    this.$root.showMessage('error', 'msg-erro-ven-cliente-mix-load');
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.page {
    position: relative;
    padding-left: 0;
    .nav-tabs-main {
        margin-bottom: 10px;
    }
    .nav-tabs-children {
        margin-bottom: 20px;
        li > a {
            text-transform: capitalize;
        }
        li > ::after {
            bottom: -4px;
            border-width: 2px;
        }
    }

    .mobile-tab {
        cursor: pointer;

        &-list {
            width: calc(100% + 40px);
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-right: 20px;
            padding-bottom: 5px;
            padding-left: 20px;
            border-bottom: 1px solid $table-border;
            justify-content: center;

            &::after {
                content: '';
                border: 3px solid $primary-color-click;
                border-radius: 100px;
                position: absolute;
                width: calc(100% - 40px);
                bottom: -3px;
            }

            &-item {
                text-transform: uppercase;
                font-weight: 600;
                color: $text-color;

                &.active {
                    color: $primary-color-click;
                }
            }
        }

        &-text {
            text-transform: uppercase;
            font-weight: 600;
            color: $primary-color-click;

            & ~ i {
                color: $primary-color-click;
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
